
export default [
	{
		path: "",
		name: "districtManagerDashboard",
		component: () => import("../pages/districtManagerDashboard.vue"),
	},
];
